export const getModuleParentPathByModuleId = (id, data, field) => {
    const numberId = Number(id);
    const item = data.find((item) => item.pk === numberId);

    if (!item.parent) {
        return [field ? item[field] : item];
    }

    return [field ? item[field] : item].concat(getModuleParentPathByModuleId(item.parent, data, field));
};
export const findModuleChildrenById = (id, data) => {
    const numberId = Number(id);
    const children = [];

    function findChildrenRecursive(parentId) {
        const directChildren = data.filter((item) => item.parent === parentId);

        for (const child of directChildren) {
            findChildrenRecursive(child.pk);
            children.push(child);
        }
    }

    findChildrenRecursive(numberId);
    return children;
};

export function getModulesTreeView(data) {
    const map = data.reduce(
        (acc, obj) => ({
            ...acc,
            [obj.pk]: {
                ...obj,
                children: [],
            },
        }),
        {},
    );

    data.forEach((obj) => {
        if (obj.parent && map[obj.parent]) {
            map[obj.parent].children.push(map[obj.pk]);
        }
    });

    return Object.values(map).filter((obj) => obj.parent === null);
}
